/* SLIDE 29 */
/* SLIDE 30 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ButtonBot from "shared/components/ButtonBot";
import Popup from "shared/components/Popup";
import closeIcon from 'assets/icons/close.svg';


const ScheduleSetting = () => {
  const navigate = useNavigate();
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showSavePopup, setShowSavePopup] = useState(false);

  const [selectedLocation, setSelectedLocation] = useState("홍길동");
  const [workDays, setWorkDays] = useState({
    monday: {
      checked: true,
      startHour: "09",
      startMinute: "00",
      endHour: "09",
      endMinute: "00",
    },
    tuesday: {
      checked: true,
      startHour: "09",
      startMinute: "00",
      endHour: "09",
      endMinute: "00",
    },
    wednesday: {
      checked: false,
      startHour: "09",
      startMinute: "00",
      endHour: "09",
      endMinute: "00",
    },
    thursday: {
      checked: false,
      startHour: "09",
      startMinute: "00",
      endHour: "09",
      endMinute: "00",
    },
    friday: {
      checked: false,
      startHour: "09",
      startMinute: "00",
      endHour: "09",
      endMinute: "00",
    },
    saturday: {
      checked: false,
      startHour: "09",
      startMinute: "00",
      endHour: "09",
      endMinute: "00",
    },
    sunday: {
      checked: false,
      startHour: "09",
      startMinute: "00",
      endHour: "09",
      endMinute: "00",
    },
  });

  const daysOfWeek = {
    monday: "월요일",
    tuesday: "화요일",
    wednesday: "수요일",
    thursday: "목요일",
    friday: "금요일",
    saturday: "토요일",
    sunday: "일요일",
  };

  const handleCheckboxChange = (day) => {
    setWorkDays({
      ...workDays,
      [day]: {
        ...workDays[day],
        checked: !workDays[day].checked,
      },
    });
  };

  const handleTimeChange = (day, timeType, value) => {
    setWorkDays({
      ...workDays,
      [day]: {
        ...workDays[day],
        [timeType]: value,
      },
    });
  };

  const handleSaveClick = () => {
    setShowSavePopup(true);
  };
  const handleCloseSavePopup = () => {
    setShowSavePopup(false);
  };
  const handleCancelClick = () => {
    setShowCancelPopup(true);
  };

  const handleCloseCancelPopup = () => {
    setShowCancelPopup(false);
  };

  const handleConfirmCancel = () => {
    // Navigate back to schedule management
    navigate("/schedule_management");
  };

  const handleSave = () => {
    // Here you would typically save the data to a backend
    console.log("Saving work schedule:", {
      location: selectedLocation,
      workDays,
    });

    // Check employee working status based on the set schedule
    checkEmployeeStatus();
    // Navigate back to schedule management after saving
    navigate("/schedule_management");
  };

  const checkEmployeeStatus = () => {
    const now = new Date();
    const day = now.getDay(); // 0 is Sunday, 1 is Monday, etc.
    const currentHour = now.getHours().toString().padStart(2, "0");
    const currentMinute = now.getMinutes().toString().padStart(2, "0");
    const dayKeys = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];

    const todayKey = dayKeys[day];
    if (!workDays[todayKey] || !workDays[todayKey].checked) {
      console.log("Employee is not scheduled to work today");
      return;
    }

    const { startHour, startMinute, endHour, endMinute } = workDays[todayKey];
    const startTime = `${startHour}:${startMinute}`;
    const endTime = `${endHour}:${endMinute}`;
    const currentTime = `${currentHour}:${currentMinute}`;

    if (currentTime >= startTime && currentTime <= endTime) {
      console.log("Employee is currently working");
    } else {
      console.log("Employee is not currently working");
    }
  };
  return (
    <div className="mn-work-schedule-container work-schedule-container px-20">
      <div className="schedule-header-container mn-schedule-header-container">
        <h2 className="schedule-title">근무 스케줄 설정</h2>
        <div className="location-dropdown">
          <select
            className="mn-input"
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
          >
            <option value="홍길동">홍길동</option>
            <option value="김철수">김철수</option>
            <option value="이영희">이영희</option>
          </select>
        </div>
      </div>

      <div className="schedule-table">
        <div className="table-header">
          <div className="col-workday">근무요일</div>
          <div className="col-time">시작시간</div>
          <div className="col-time">종료시간</div>
        </div>

        {Object.keys(daysOfWeek).map((day) => (
          <div className="table-row" key={day}>
            <div className="col-workday">
              <label className="checkbox-container">
                <input
                  type="checkbox"
                  checked={workDays[day].checked}
                  onChange={() => handleCheckboxChange(day)}
                />
                <span className="checkmark"></span>
                {daysOfWeek[day]}
              </label>
            </div>
            <div className="col-time time-inputs">
              <input
                type="text"
                className="time-input"
                value={workDays[day].startHour}
                onChange={(e) =>
                  handleTimeChange(day, "startHour", e.target.value)
                }
                disabled={!workDays[day].checked}
                maxLength="2"
              />
              <span className="time-separator">:</span>
              <input
                type="text"
                className="time-input"
                value={workDays[day].startMinute}
                onChange={(e) =>
                  handleTimeChange(day, "startMinute", e.target.value)
                }
                disabled={!workDays[day].checked}
                maxLength="2"
              />
            </div>
            <div className="col-separator">~</div>
            <div className="col-time time-inputs">
              <input
                type="text"
                className="time-input"
                value={workDays[day].endHour}
                onChange={(e) =>
                  handleTimeChange(day, "endHour", e.target.value)
                }
                disabled={!workDays[day].checked}
                maxLength="2"
              />
              <span className="time-separator">:</span>
              <input
                type="text"
                className="time-input"
                value={workDays[day].endMinute}
                onChange={(e) =>
                  handleTimeChange(day, "endMinute", e.target.value)
                }
                disabled={!workDays[day].checked}
                maxLength="2"
              />
            </div>
          </div>
        ))}
      </div>
      <ButtonBot
        textYes="저장하기"
        textNo="취소하기"
        handleYes={handleSaveClick}
        handleNo={handleCancelClick}
      />

      {/* Save Confirmation Popup */}
      {showSavePopup && (
        <Popup title="스케줄 저장" textYes="저장" textNo="닫기" handleYes={handleSave} handleNo={handleCloseSavePopup} setVisible={setShowSavePopup}>
          <div className="confirm-popup-body">

            <p>변경된 스케줄이 저장됩니다.</p>
            <p>저장하시겠습니까?</p>
          </div>
         

        </Popup>
      )}

      {/* Cancel Confirmation Popup */}
      {showCancelPopup && (
        <Popup title="스케줄 취소" textYes="취소" textNo="닫기" handleYes={handleSave} handleNo={handleCloseCancelPopup} setVisible={setShowCancelPopup}>
          <div className="confirm-popup-body">

            <p>변경사항이 저장되지 않습니다.</p>
            <p>취소하시겠습니까?</p>
          </div>
         

        </Popup>
      )}
    </div>
  );
};

export default ScheduleSetting;
